module.exports = __webpack_public_path__ + "img/Kate - Slider 01.7bf203b5.jpg";